import React from 'react';
import Box from '../Box/Box';
import { css } from 'styled-components';
import { theme } from '../../../config/theme';

export const ScrollIndicatorProgressBar = () => {
    const [value, setValue] = React.useState(0);
    const onScroll = () => {
        let winScroll =
            window.pageYOffset ||
            document.body.scrollTop ||
            document.documentElement.scrollTop;

        const height =
            document.documentElement.scrollHeight -
            document.documentElement.clientHeight;
        const scrolled = (winScroll / height) * 100;
        setValue(scrolled);
    };

    React.useEffect(() => {
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <Box
            as="progress"
            max="100"
            value={value}
            width="100%"
            height="5px"
            border="0"
            position="absolute"
            top="90px"
            zIndex="1"
            display="flex"
            marginBottom="-10px"
            css={css`
                &::-webkit-progress-bar {
                    background-color: transparent;
                }
                &::-webkit-progress-value {
                    background: ${theme.colors.primary.main};
                }
            `}
        />
    );
};
